// Lead-sheet chord spelling: root large, ♯/♭ glyphs, minor "m" on the baseline, extensions superscript,
// slash bass after a "/" (e.g. "C#m7/G#" → C♯m⁷/G♯). `added` is the trailing part a play style added
// ("7", "sus4", "/F#"): it is drawn in accent so the analyzed chord stays readable.
const ACC: Record<string, string> = { "#": "♯", b: "♭" };

function split(sym: string) {
  const m = /^([A-G])([#b]?)(m(?!aj))?(.*)$/.exec(sym);
  if (!m) return null;
  return { root: m[1] + (ACC[m[2]] ?? ""), minor: !!m[3], ext: m[4] };
}

export function ChordName({ chord, added = "" }: { chord: string; added?: string }) {
  const [main, bass] = chord.split("/");
  const p = split(main);
  if (!p) return <>{chord}</>;
  const b = bass ? split(bass) : null;
  const addedBass = added.startsWith("/");
  const extAdded = !addedBass && added && p.ext.endsWith(added) ? added : "";
  const extOwn = p.ext.slice(0, p.ext.length - extAdded.length);
  return (
    <span className="chord-name">
      {p.root}
      {p.minor && <span className="cn-q">m</span>}
      {p.ext && <sup>{extOwn}{extAdded && <span className="cn-add">{extAdded}</span>}</sup>}
      {bass && <span className={"cn-bass" + (addedBass ? " cn-add" : "")}>/{b ? b.root : bass}</span>}
    </span>
  );
}
